<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>
      Menu.ly es una aplicación para escanear el menú de un restaurante, elegir tus platillos, pagar y comer.

      <!--<a href="https://cli.vuejs.org" target="_blank" rel="noopener">vue-cli documentation</a>.-->
    </p>
    <br>
    <section class="hero is-primary">
      <div class="hero-body">
        <h1 class="title is-3">Restaurantes asociados</h1>
        <ul>
          <li><a href="http://pinocchiolloret.com/" target="_blank" rel="noopener">pinocchio</a></li>
          <li><a href="https://www.facebook.com/Coffee-People-113173740061455" target="_blank" rel="noopener">Coffee and People</a></li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #74521f;
}
</style>
